var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavLinkMassege(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_775_67262)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7617 16.0713C19.3609 16.9166 18.4997 17.5018 17.502 17.502H2.50195C1.50405 17.502 0.642127 16.9168 0.241211 16.0713L8.45312 11.0381L10.002 11.9844L11.5498 11.0381L19.7617 16.0713ZM7.25586 10.3057L0.00195312 14.752V5.87305L7.25586 10.3057ZM20.002 14.752L12.748 10.3057L20.002 5.87305V14.752ZM17.502 2.50195C18.6913 2.50213 19.6866 3.33242 19.9395 4.44531L10.002 10.5186L0.0634766 4.44531C0.316318 3.33228 1.31239 2.50195 2.50195 2.50195H17.502Z",
    fill: "#212529"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_775_67262"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavLinkMassege);
export default __webpack_public_path__ + "static/media/nav-link-massege.c8464b79dcc84ec265751cabafd76e5c.svg";
export { ForwardRef as ReactComponent };